import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

import { cn, formatDate, getFullName, getReadTime } from '@/_lib/utils'
import { IBlogPostReduced } from '@/_types'

import { getBlogPostCover, getBlogPostCoverMobile } from '../utils/blog.utils'

interface IProps {
	article: IBlogPostReduced
}

const ABlogArticleCard: React.FC<IProps> = ({ article }) => {
	const blurDataURL =
		'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k='
	const blogPostCover = getBlogPostCover(article)
	const blogPostCoverMobile = getBlogPostCoverMobile(article)

	return (
		<article className={cn('item_article', blogPostCover ? '' : 'item_article--no-image')}>
			<Link
				href={`/clanky/${article.slug}`}
				title=''
				className='item_article_img'
				prefetch={true}
			>
				{blogPostCover ? (
					<Image
						src={blogPostCover.url}
						alt={article.title}
						className='hide_mdm'
						loading='lazy'
						sizes='(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 430px'
						quality={85}
						placeholder='blur'
						width={450}
						height={275}
						blurDataURL={blurDataURL}
						unoptimized={true}
					/>
				) : (
					<div className='hide_mdm placeholder-image'></div>
				)}
				{blogPostCoverMobile ? (
					<Image
						src={blogPostCoverMobile.url}
						alt={article.title}
						className='hide_md'
						loading='lazy'
						sizes='(max-width: 768px) 100vw, 430px'
						quality={85}
						placeholder='blur'
						blurDataURL={blurDataURL}
						width={430}
						height={287}
						unoptimized={true}
					/>
				) : (
					<div className='hide_md placeholder-image'></div>
				)}
				<div className='item_article_read'>
					<Image
						src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/icons/read-time.svg`}
						alt='Read Time'
						className='sico'
						width={20}
						height={14}
						loading='lazy'
						unoptimized={true}
					/>
					<span>{getReadTime(article.wordCount)} min</span>
				</div>
			</Link>
			<div className='item_article_params'>
				<div className='item_article_params_left min-h-[25px]'>
					<time className='item_article_date'>{formatDate(article.publishedAt)}</time>
					{article.authors.length > 0 && (
						<div className='item_article_autor'>
							{article.authors.map(author => getFullName(author)).join(', ')}
						</div>
					)}
				</div>
				<div className='item_article_params_right min-h-[53px]'>
					<div className='item_tags'>
						{article.categories.map(category => (
							<Link
								key={category.id}
								href={`/clanky?category=${category.slug}`}
								style={{ cursor: 'pointer' }}
								prefetch={false}
							>
								<span>{category.name}</span>
							</Link>
						))}
					</div>
				</div>
			</div>
			<h2 className='item_article_title'>
				<Link href={`/clanky/${article.slug}`} prefetch={true}>
					{article.title}
				</Link>
			</h2>
			<div className='item_article_bottom'>
				<Link
					href={`/clanky/${article.slug}`}
					title='Otvoriť článok'
					className='btn_default_o'
					prefetch={true}
				>
					Čítať viac
				</Link>
			</div>
		</article>
	)
}

export default ABlogArticleCard
